import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import Join from "../Components/auth/join";
import SignIn from "../Components/auth/signin";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import { Link, useNavigate } from "react-router-dom";
import logo from "../Ui/logo4.png";
import { auth } from "../firebase";
import StyleNav from "./navbar.module.css";
import { motion } from "framer-motion";
import { IoLogInOutline } from "react-icons/io5";
import { VscSignIn } from "react-icons/vsc";
import DialogBox from "../Components/dialog";

const Navbar = () => {
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await auth.signOut();
    handleMenuClose();
    navigate("/");
  };

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const goToDashboard = () => {
    handleMenuClose();
    navigate("/patientdash");
  };

  const toggleDrawer = (open) => () => setDrawerOpen(open);
  const [dialogMode, setDialogMode] = useState(null);

  const handleJoin = () => {
    setDialogMode("join");
    setDialogOpen(true);
  };

  const handleSignin = () => {
    setDialogMode("signin");
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setDialogMode(null);
  };

  const navLinks = [
    { text: "Home", path: "/" },
    { text: "About Us", path: "/about" },
    { text: "Departments", path: "/departments" },
    { text: "Doctors", path: "/doctors" },
    { text: "Blogs", path: "/blogs" },
    { text: "Contact Us", path: "/contact" },
  ];

  return (
    <AppBar position="static" color="default" className={StyleNav.navbar}>
      <Toolbar className={StyleNav.toolbar}>
        <div>
          <img src={logo} alt="logo" className={StyleNav.logo} />
        </div>

        {isMobile ? (
          <div className={StyleNav.icons}>
            <IconButton component={Button} onClick={handleJoin}>
              <IoLogInOutline size={28} color="#333" />
            </IconButton>
            <IconButton component={Button} onClick={handleSignin}>
              <VscSignIn size={24} color="#333" />
            </IconButton>

            <DialogBox
              open={dialogOpen}
              handleClose={handleDialogClose}
              mode={dialogMode}
              switchMode={setDialogMode}
            />

            <IconButton color="inherit" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={toggleDrawer(false)}
              sx={{
                "& .MuiDrawer-paper": {
                  width: "240px",
                  background: "rgba(255, 255, 255, 0.6)", // translucent white
                  backdropFilter: "blur(50px)", // the actual blur
                  WebkitBackdropFilter: "blur(10px)", // Safari support
                  transition: "transform 0.4s ease-in-out",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                  padding: "1rem",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                },
              }}
            >
              <motion.div
                variants={{
                  hidden: {},
                  visible: {
                    transition: {
                      staggerChildren: 0.2, // Delay between items
                    },
                  },
                }}
                initial="hidden"
                animate="visible"
              >
                <List>
                  {navLinks.map((link, index) => (
                    <motion.div
                      key={index}
                      variants={{
                        hidden: { opacity: 0, y: 50 },
                        visible: {
                          opacity: 1,
                          y: 0,
                          transition: { duration: 0.5 },
                        },
                      }}
                    >
                      <ListItem
                        button
                        component={Link}
                        to={link.path}
                        onClick={toggleDrawer(false)}
                      >
                        <ListItemText primary={link.text} />
                      </ListItem>
                    </motion.div>
                  ))}
                </List>
              </motion.div>

              {/* {!user ? (
                <>
                  <ListItem button component={Link} to="/login">
                    <ListItemText primary="Login" />
                  </ListItem>
                  <ListItem button component={Link} to="/signin">
                    <ListItemText primary="Sign In" />
                  </ListItem>
                </>
              ) : (
                <>
                  <ListItem button onClick={goToDashboard}>
                    <ListItemText primary="Dashboard" />
                  </ListItem>
                  <ListItem disabled>
                    <ListItemText primary="Settings" />
                  </ListItem>
                  <ListItem button onClick={handleSignOut}>
                    <ListItemText primary="Sign Out" />
                  </ListItem>
                </>
              )} */}
            </Drawer>
          </div>
        ) : (
          <div className={StyleNav.navbarContent}>
            <ul className={StyleNav.NavbarMenu}>
              {navLinks.map((link) => (
                <li key={link.text} className={StyleNav.NavbarMenuList}>
                  <Link to={link.path}>{link.text}</Link>
                </li>
              ))}
            </ul>
            <div className={StyleNav.button}>
              {!user ? (
                <>
                  <Button variant="outlined" onClick={handleJoin}>
                    Join
                  </Button>
                  <Button variant="contained" onClick={handleSignin}>
                    Sign In
                  </Button>

                  <DialogBox
                    open={dialogOpen}
                    handleClose={handleDialogClose}
                    mode={dialogMode}
                    switchMode={setDialogMode}
                  />
                </>
              ) : (
                <>
                  <IconButton onClick={handleMenuOpen}>
                    <Avatar>{user.email[0].toUpperCase()}</Avatar>
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={goToDashboard}>Dashboard</MenuItem>
                    <MenuItem disabled>Settings</MenuItem>
                    <MenuItem onClick={handleSignOut}>Sign Out</MenuItem>
                  </Menu>
                </>
              )}
            </div>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
